import { Box, CircularProgress } from '@mui/material'
import React, { useEffect } from 'react'
import EmptyScreen from '../../../../components/EmptyScreen'
import ProfileReview from '../../../../components/profile/ProfileReview'
import {
  MOBILE_APP_HEIGHT,
  MOBILE_NAV_HEIGHT,
  MOBILE_SEARCH_HEIGHT,
} from '../../../../helpers/static-constants'
import { useDevice } from '../../../../hooks/useDevice'
import useAppUtilities from '../../../../hooks/useAppUtilities'
import { useAppSelector } from '../../../../store'
import {
  selectEater,
  selectProfileRestaurantReviews,
  selectProfileRestaurantReviewsLoading,
  selectProfileRestaurantReviewsError,
  fetchEaterRestaurantReviews,
} from '../../../../store/profileSlice'
import { selectIsMobileSearch } from '../../../../store/searchSlice'
import {
  ProfileReviewTabInnerGrid,
  ProfileReviewTabMainGrid,
} from '../styled/ProfileReviewTab.styled'

const ProfileReviewTab: React.FC = () => {
  const { dispatch } = useAppUtilities()
  const isMobileSearch = useAppSelector(selectIsMobileSearch)
  const { isHybrid } = useDevice()
  const eater = useAppSelector(selectEater)
  const restaurantReviews = useAppSelector(selectProfileRestaurantReviews)
  const loading = useAppSelector(selectProfileRestaurantReviewsLoading)
  const error = useAppSelector(selectProfileRestaurantReviewsError)

  // Fetch reviews on mount if eater exists and list is empty
  useEffect(() => {
    if (eater?.eaterId && restaurantReviews.length === 0 && !loading && !error) {
      void dispatch(
        fetchEaterRestaurantReviews({
          eaterId: eater.eaterId,
          page: 0,
          limit: 20,
        }),
      )
    }
    // eslint-disable-next-line
  }, [eater?.eaterId]) // Only re-fetch if eaterId changes, not on every state update

  if (loading && restaurantReviews.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '400px',
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  if (error && restaurantReviews.length === 0) {
    return (
      <EmptyScreen
        mainText="Unable to load reviews"
        secondaryText={error}
        imageUrl="/images/empty-screen.svg"
        containerHeight={'400px'}
      />
    )
  }

  return (
    <>
      {restaurantReviews.length > 0 ? (
        <Box
          sx={{
            height: {
              xs: `calc(100vh - ${
                isMobileSearch
                  ? `${
                      MOBILE_SEARCH_HEIGHT +
                      MOBILE_NAV_HEIGHT +
                      (isHybrid ? (MOBILE_APP_HEIGHT as number) : 0) +
                      322
                    }px`
                  : `${MOBILE_NAV_HEIGHT + 286}px`
              })`,
              md: '100%',
            },
            overflow: 'auto',
            my: { xs: '16px', md: '40px' },
          }}
        >
          <ProfileReviewTabMainGrid>
            {restaurantReviews.map((item, index) => {
              return (
                <ProfileReviewTabInnerGrid key={item.restaurantReviewId || index}>
                  <ProfileReview review={item} />
                </ProfileReviewTabInnerGrid>
              )
            })}
          </ProfileReviewTabMainGrid>
        </Box>
      ) : (
        <EmptyScreen
          mainText="No data available"
          secondaryText="No reviews found"
          imageUrl="/images/empty-screen.svg"
          containerHeight={'400px'}
        />
      )}
    </>
  )
}

export default ProfileReviewTab
